"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var warning = exports.warning = function warning(condition, message) {
  if (condition) {
    return;
  }
  if (process.env.NODE_ENV !== "production") {
    console.warn(message);
  }
};
var _default = exports.default = warning;